import { View, Text, XStack, YStack } from "tamagui";
import Avatar from "./Avatar";
import { StarIcon } from "./design-system/icons";
import { BreakfastClub } from "./icons/BreakfastClub";
import type { Profile } from "../types/profile";
import { brandShadowSm } from "../../tamagui.config";

type ProfileCardProps = {
  profile: Profile | null;
};

export const ProfileCard = ({ profile }: ProfileCardProps) => {
  const role = profile?.roles?.[0]?.role ?? "Member";
  const roleDisplay =
    role === "PaidMember" ? "Club" : role.split(/(?=[A-Z])/).join(" ");

  return (
    <XStack
      bg="$brandParchment"
      borderRadius={12}
      w="100%"
      h="100%"
      p="$4"
      justifyContent="space-between"
      alignItems="center"
    >
      <YStack flex={1} justifyContent="center" pr="$3">
        <BreakfastClub width="100%" />
        <Text fontSize={20} mb="$1">
          {profile?.name}
        </Text>
        <Text fontSize={16} mb="$1">
          {roleDisplay}
        </Text>
        <Text fontSize={16} mb="$1">
          Favorite Breakfast{"\n"}food: {profile?.breakfast_food}
        </Text>
        {role !== "Member" ? <StarIcon width={40} height={40} /> : null}
      </YStack>

      <View
        borderWidth={1}
        borderColor="black"
        borderRadius={999}
        {...brandShadowSm}
      >
        <Avatar
          size={100}
          imageStyle={{ borderRadius: 999 }}
          url={profile?.avatar_url ?? null}
        />
      </View>
    </XStack>
  );
};
